import { media, styled } from '@styles';

export const Wrapper = styled.div`
  width: 45vw;
  max-width: 860px;
  margin: 0 auto;

  ${media.largeScreen`
    max-width: 640px;
    width: 50vw;
  `}
  ${media.mediumScreen`
    max-width: 520px;
    width: 68vw;
  `}
  ${media.smallScreen`
    width: 85vw;
  `}

  p {
    font-family: ${(props) => props.theme.typography.extraFontFamily};
    font-size: ${(props) => props.theme.typography.baseFontSize};
    font-weight: 500;
    font-size: 20px;
    line-height: 180%;
  }
`;
